var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  \t.red{ fill: #F70D0D; }\n  \t.white{ fill: #FFFFFF; }\n  \t.black{ fill: #000000; }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "k1-mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "k1-mask-a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M125,75H24.5C12.7,75,3,65.3,3,53.5v0C3,41.7,12.7,32,24.5,32H125c11.8,0,21.5,9.7,21.5,21.5v0C146.5,65.3,136.8,75,125,75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k1-mask-b",
    transform: "translate(125, 125) rotate(-180)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-125, -125)",
    className: "black",
    d: "M31.6,125.5c0.4-51.9,42.3-93.9,93.9-93.9v-6.1c-54.9,0-99.6,44.8-100,100H31.6z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k1MaskPauseA",
    begin: "0; k1MaskPauseC.end;",
    dur: "820ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k1MaskPlayA",
    begin: "k1MaskPauseA.end;",
    from: 0,
    to: 180,
    dur: "500ms",
    repeatCount: 1,
    fill: "freeze",
    type: "rotate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k1MaskPauseB",
    begin: "k1MaskPlayA.end;",
    dur: "2000ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k1MaskPlayB",
    begin: "k1MaskPauseB.end;",
    from: 180,
    to: 360,
    dur: "500ms",
    repeatCount: 1,
    fill: "freeze",
    type: "rotate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k1MaskPauseC",
    begin: "k1MaskPlayB.end;",
    dur: "780ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "k2-mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "k2-mask-a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M196.5,146.5c-11.9,0-21.5-9.6-21.5-21.5c0-27.5-22.4-49.9-50-50c-11.9,0-21.5-9.7-21.4-21.6c0-11.9,9.7-21.4,21.5-21.4c0,0,0,0,0.1,0c51.2,0.1,92.8,41.9,92.8,93C218,136.9,208.4,146.5,196.5,146.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k2-mask-b",
    transform: "translate(-110, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "black",
    x: 125,
    y: 75,
    width: 110,
    height: 6
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k2MaskPauseA",
    begin: "0; k2MaskPauseC.end;",
    dur: "1230ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k2MaskPlayA",
    begin: "k2MaskPauseA.end;",
    from: "0 0",
    to: "110 0",
    dur: "300ms",
    repeatCount: 1,
    fill: "freeze",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k2MaskPauseB",
    begin: "k2MaskPlayA.end;",
    dur: "2050ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k2MaskPlayB",
    begin: "k2MaskPauseB.end",
    from: "110 0",
    to: "2200 0",
    dur: "300ms",
    repeatCount: 1,
    fill: "freeze",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k2MaskPauseC",
    begin: "k2MaskPlayB.end;",
    dur: "720ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "k3-mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "k3-mask-a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M125,218c-11.9,0-21.5-9.6-21.5-21.5S113.1,175,125,175c27.6,0,50-22.4,50-50c0-11.9,9.6-21.5,21.5-21.5S218,113.1,218,125C218,176.3,176.3,218,125,218z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "k4-mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "k4-mask-a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M125,218c-51.3,0-93-41.7-93-93c0-11.9,9.6-21.5,21.5-21.5S75,113.1,75,125c0,27.6,22.4,50,50,50c11.9,0,21.5,9.6,21.5,21.5S136.9,218,125,218z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "k5-mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "k5-mask-a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M53.5,146.5c-11.9,0-21.5-9.6-21.5-21.5c0-51.3,41.7-93,92.9-93c11.9,0,21.5,9.6,21.5,21.5S136.8,75,124.9,75C97.4,75,75,97.4,75,125C75,136.9,65.4,146.5,53.5,146.5z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "k6-mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "k6-mask-a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M225.5,75H125c-11.8,0-21.5-9.7-21.5-21.5v0c0-11.8,9.7-21.5,21.5-21.5h100.5c11.8,0,21.5,9.7,21.5,21.5v0C247,65.3,237.3,75,225.5,75z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k1-mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "k1",
    className: "red",
    d: "M125,75H24.5C12.7,75,3,65.3,3,53.5v0C3,41.7,12.7,32,24.5,32H125c11.8,0,21.5,9.7,21.5,21.5v0C146.5,65.3,136.8,75,125,75z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k1PlayA",
    begin: "0; k1PauseB.end;",
    from: "0 0",
    to: "145 0",
    dur: "300ms",
    repeatCount: 1,
    fill: "freeze",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k1PauseA",
    begin: "k1PlayA.end;",
    dur: "2000ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k1PlayB",
    begin: "k1PauseA.end;",
    from: "145 0",
    to: "290 0",
    dur: "300ms",
    repeatCount: 1,
    fill: "freeze",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k1PauseB",
    begin: "k1PlayB.end;",
    dur: "2000ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k2-mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125, 125) rotate(-180)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "k2",
    transform: "translate(-125, -125)",
    className: "red",
    d: "M196.5,146.5c-11.9,0-21.5-9.6-21.5-21.5c0-27.5-22.4-49.9-50-50c-11.9,0-21.5-9.7-21.4-21.6c0-11.9,9.7-21.4,21.5-21.4c0,0,0,0,0.1,0c51.2,0.1,92.8,41.9,92.8,93C218,136.9,208.4,146.5,196.5,146.5z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k2PauseA",
    begin: "0; k2PauseC.end;",
    dur: "70ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k2PlayA",
    begin: "k2PauseA.end;",
    from: 0,
    to: 180,
    dur: "500ms",
    repeatCount: 1,
    fill: "freeze",
    type: "rotate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k2PauseB",
    begin: "k2PlayA.end;",
    dur: "1970ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k2PlayB",
    begin: "k2PauseB.end;",
    from: 180,
    to: 359,
    dur: "500ms",
    repeatCount: 1,
    fill: "freeze",
    type: "rotate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k2PauseC",
    begin: "k2PlayB.end;",
    dur: "1560ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k3-mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125, 125) rotate(-180)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "k3",
    transform: "translate(-125, -125)",
    className: "red",
    d: "M125,218c-11.9,0-21.5-9.6-21.5-21.5S113.1,175,125,175c27.6,0,50-22.4,50-50c0-11.9,9.6-21.5,21.5-21.5S218,113.1,218,125C218,176.3,176.3,218,125,218z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k3PauseA",
    begin: "0; k3PauseC.end;",
    dur: "320ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k3PlayA",
    begin: "k3PauseA.end;",
    from: 0,
    to: 180,
    dur: "500ms",
    repeatCount: 1,
    fill: "freeze",
    type: "rotate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k3PauseB",
    begin: "k3PlayA.end;",
    dur: "1960ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k3PlayB",
    begin: "k3PauseB.end;",
    from: 180,
    to: 359,
    dur: "500ms",
    repeatCount: 1,
    fill: "freeze",
    type: "rotate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k3PauseC",
    begin: "k3PlayB.end;",
    dur: "1320ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k4-mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125, 125) rotate(-180)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "k4",
    transform: "translate(-125, -125)",
    className: "red",
    d: "M125,218c-51.3,0-93-41.7-93-93c0-11.9,9.6-21.5,21.5-21.5S75,113.1,75,125c0,27.6,22.4,50,50,50c11.9,0,21.5,9.6,21.5,21.5S136.9,218,125,218z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k4PauseA",
    begin: "0; k4PauseC.end;",
    dur: "570ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k4PlayA",
    begin: "k4PauseA.end;",
    from: 0,
    to: 180,
    dur: "500ms",
    repeatCount: 1,
    fill: "freeze",
    type: "rotate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k4PauseB",
    begin: "k4PlayA.end;",
    dur: "2000ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k4PlayB",
    begin: "k4PauseB.end;",
    from: 180,
    to: 359,
    dur: "500ms",
    repeatCount: 1,
    fill: "freeze",
    type: "rotate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k4PauseC",
    begin: "k4PlayB.end;",
    dur: "1030ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k5-mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125, 125) rotate(-180)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "k5",
    transform: "translate(-125, -125)",
    className: "red",
    d: "M53.5,146.5c-11.9,0-21.5-9.6-21.5-21.5c0-51.3,41.7-93,92.9-93c11.9,0,21.5,9.6,21.5,21.5S136.8,75,124.9,75C97.4,75,75,97.4,75,125C75,136.9,65.4,146.5,53.5,146.5z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k5PauseA",
    begin: "0; k5PauseC.end;",
    dur: "820ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k5PlayA",
    begin: "k5PauseA.end;",
    from: 0,
    to: 180,
    dur: "500ms",
    repeatCount: 1,
    fill: "freeze",
    type: "rotate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k5PauseB",
    begin: "k5PlayA.end;",
    dur: "2000ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k5PlayB",
    begin: "k5PauseB.end;",
    from: 180,
    to: 359,
    dur: "500ms",
    repeatCount: 1,
    fill: "freeze",
    type: "rotate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k5PauseC",
    begin: "k5PlayB.end;",
    dur: "780ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k6-mask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "k6",
    className: "red",
    d: "M225.5,75H125c-11.8,0-21.5-9.7-21.5-21.5v0c0-11.8,9.7-21.5,21.5-21.5h100.5c11.8,0,21.5,9.7,21.5,21.5v0C247,65.3,237.3,75,225.5,75z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k6PauseA",
    begin: "0; k6PauseC.end;",
    dur: "1230ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k6PlayA",
    begin: "k6PauseA.end;",
    from: "0 0",
    to: "145 0",
    dur: "300ms",
    repeatCount: 1,
    fill: "freeze",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k6PauseB",
    begin: "k6PlayA.end;",
    dur: "2050ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k6PlayB",
    begin: "k6PauseB.end;",
    from: "145 0",
    to: "290 0",
    dur: "300ms",
    repeatCount: 1,
    fill: "freeze",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "k6PauseC",
    begin: "k6PlayB.end;",
    dur: "720ms",
    type: "translate",
    attributeType: "XML",
    attributeName: "transform"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.65a8f89e5e8335dd18b428b56cc6725c.svg";
export { ForwardRef as ReactComponent };